import __request__ from "routing/request";
export function get() {
  return __request__("GET", "/search/decorators", null, {}, {
    "Accept": ["application/json"]
  });
}
export function create(JSONbody) {
  return __request__("POST", "/search/decorators", JSONbody, {}, {
    "Accept": ["application/json"]
  });
}
export function getAvailable() {
  return __request__("GET", "/search/decorators/available", null, {}, {
    "Accept": ["application/json"]
  });
}
export function update(decoratorId, JSONbody) {
  return __request__("PUT", `/search/decorators/${decoratorId}`, JSONbody, {}, {
    "Accept": ["application/json"]
  });
}
export function remove(decoratorId) {
  return __request__("DELETE", `/search/decorators/${decoratorId}`, null, {}, {
    "Accept": ["application/json"]
  });
}
